import { render, staticRenderFns } from "./timespanDetails.vue?vue&type=template&id=5cb3a120&"
import script from "./timespanDetails.vue?vue&type=script&lang=js&"
export * from "./timespanDetails.vue?vue&type=script&lang=js&"
import style0 from "./timespanDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports